import { render, staticRenderFns } from "./BaseIconRoundButtonRemove.vue?vue&type=template&id=39b1aa1f&scoped=true&"
import script from "./BaseIconRoundButtonRemove.vue?vue&type=script&lang=js&"
export * from "./BaseIconRoundButtonRemove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b1aa1f",
  null
  
)

export default component.exports